import { useParams } from '@thd-olt-component-react/router';
import {
  Utils,
  QUERY_PARAM_DRAFT_OMSID,
  QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS,
  QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS,
  QUERY_PARAM_PLA_CONFIGURATION_GUID,
  QUERY_PARAM_REGION_ID,
  QUERY_STORE_ID,
  QUERY_STORE_ZIPCODE
} from '../app/utils/urlUtils';

export const useDraftOmsId = () => {
  const { omsId } = useParams();
  const draftOmsId = Utils.getParameterByName(QUERY_PARAM_DRAFT_OMSID) || null;
  return ({ omsId: draftOmsId || omsId });
};

export const usePlaConfigurationsParams = () => {
  /* eslint-disable-next-line max-len */
  const baseConfigurationIdForSelections = Utils.getParameterByName(QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS) || undefined;
  /* eslint-disable-next-line max-len */
  const configurationIdForSelections = Utils.getParameterByName(QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS) || undefined;
  const plaGuid = Utils.getParameterByName(QUERY_PARAM_PLA_CONFIGURATION_GUID) || undefined;
  const regionId = Utils.getParameterByName(QUERY_PARAM_REGION_ID) || undefined;

  return ({ baseConfigurationIdForSelections, configurationIdForSelections, plaGuid, regionId });
};

export const useStoreIdZipcodeParams = () => {
  const paramStoreId = Utils.getParameterByName(QUERY_STORE_ID) || undefined;
  const paramZipcode = Utils.getParameterByName(QUERY_STORE_ZIPCODE) || undefined;

  return ({ paramStoreId, paramZipcode });
};